import { render, staticRenderFns } from "./OneUpload.vue?vue&type=template&id=640d1eb1&"
import script from "./OneUpload.vue?vue&type=script&lang=js&"
export * from "./OneUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports